// @ts-check
export class ReactiveProp {
  constructor (initialState) {
    this.state = initialState
    this.subscribers = []
  }

  get () {
    return this.state
  }

  /**
   * Updates the value
   * @param {unknown} value
   * @param {string} [message] Useful if you need to know where the update came from (e.g. to prevent circular calls)
   * @returns
   */
  set (value, message) {
    if (this.state === value) {
      return
    }
    this.state = value
    this.subscribers.forEach((subscriber) => {
      subscriber(value, message)
    })
  }

  /**
   * @param {Function} callback
   */
  subscribe (callback) {
    this.subscribers.push(callback)
  }

  /**
   * @param {Function} callback
   */
  unsubscribe (callback) {
    const index = this.subscribers.indexOf(callback)
    if (index !== -1) {
      this.subscribers.splice(index, 1)
    }
  }
}

export const reactiveStore = {
  mapReady: new ReactiveProp(false),

  editMode: new ReactiveProp('change'),

  features: new ReactiveProp([]),
  selectedFeatureId: new ReactiveProp(''),

  jobData: new ReactiveProp(window['jobMetadata'] || {}), // eslint-disable-line dot-notation

  /**
   * Per-overlay settings keyed by storagePath
   */
  overlayMaps: new ReactiveProp(
    (window['mapOverlays'] || []).map((overlay) => ({ // eslint-disable-line dot-notation
      storagePath: overlay.storage_path,
      opacity: typeof overlay.opacity === 'number' ? overlay.opacity : 0.7,
      moveWith: true
    }))
  ),

  tileType: new ReactiveProp('os'), // 'os' or 'satellite'
  snap: new ReactiveProp(false)
}
